const resources = {
  en: {
    growthProgram: {
      title: 'Growth program',
      description: 'Keep today’s commitments, paused projects, and recovery notes in one restrained workspace.',
      sections: {
        today: {
          title: 'Today’s steps',
          description: 'Update today’s work without changing the existing scheduling logic.',
        },
        paused: {
          title: 'Paused projects',
          description: 'Resume projects when they are ready to return to the daily queue.',
        },
      },
      actions: {
        addProject: 'Add project',
        edit: 'Edit',
        pause: 'Pause',
        start: 'Start',
        delete: 'Delete',
        addReason: 'Add reason',
        done: 'Done',
        save: 'Save',
      },
      placeholders: {
        plan: 'What will you do?',
        note: 'Note or reason',
      },
      popconfirm: {
        deleteProject: 'Delete this project?',
      },
      empty: {
        noSteps: 'No steps',
        noPaused: 'No paused projects',
      },
      modals: {
        violation: {
          title: 'Explain missed step',
          reason: 'Why not done?',
          plan: 'Plan for tomorrow',
          impact: 'Impact',
          impactOptions: {
            shiftDeadline: 'Shift deadline',
            minor: 'Minor, will compensate',
          },
        },
        project: {
          addTitle: 'Add project',
          editTitle: 'Edit project',
          name: 'Name',
          deadline: 'Deadline',
        },
      },
      messages: {
        loadError: 'Failed to load steps',
        saved: 'Saved',
        recorded: 'Recorded',
        projectAdded: 'Project added',
        projectUpdated: 'Project updated',
        projectDeleted: 'Project deleted',
        projectStarted: 'Project started',
        projectPaused: 'Project paused',
      },
    },
  },
  uk: {
    growthProgram: {
      title: 'Програма росту',
      description: 'Тримайте сьогоднішні кроки, призупинені проєкти та пояснення пропусків в одному стриманому просторі.',
      sections: {
        today: {
          title: 'Кроки на сьогодні',
          description: 'Оновлюйте план на сьогодні без змін у наявній логіці планування.',
        },
        paused: {
          title: 'Призупинені проєкти',
          description: 'Поверніть проєкт у щоденну чергу, коли будете готові.',
        },
      },
      actions: {
        addProject: 'Додати проєкт',
        edit: 'Редагувати',
        pause: 'Пауза',
        start: 'Запустити',
        delete: 'Видалити',
        addReason: 'Додати причину',
        done: 'Виконано',
        save: 'Зберегти',
      },
      placeholders: {
        plan: 'Що ви зробите?',
        note: 'Нотатка або причина',
      },
      popconfirm: {
        deleteProject: 'Видалити цей проєкт?',
      },
      empty: {
        noSteps: 'Немає кроків',
        noPaused: 'Немає призупинених проєктів',
      },
      modals: {
        violation: {
          title: 'Пояснити пропущений крок',
          reason: 'Чому не виконано?',
          plan: 'План на завтра',
          impact: 'Вплив',
          impactOptions: {
            shiftDeadline: 'Перенести дедлайн',
            minor: 'Незначно, надолужу',
          },
        },
        project: {
          addTitle: 'Додати проєкт',
          editTitle: 'Редагувати проєкт',
          name: 'Назва',
          deadline: 'Дедлайн',
        },
      },
      messages: {
        loadError: 'Не вдалося завантажити кроки',
        saved: 'Збережено',
        recorded: 'Зафіксовано',
        projectAdded: 'Проєкт додано',
        projectUpdated: 'Проєкт оновлено',
        projectDeleted: 'Проєкт видалено',
        projectStarted: 'Проєкт запущено',
        projectPaused: 'Проєкт призупинено',
      },
    },
  },
}

export default resources
